import { useState, useEffect } from 'react';

const DEFAULT_BREAKPOINT = 768;

/**
 * Viewport-based mobile detection. Updates on resize / breakpoint changes.
 */
const useIsMobile = (breakpoint: number = DEFAULT_BREAKPOINT): boolean => {
  const getMatches = () =>
    typeof window !== 'undefined'
      ? window.matchMedia(`(max-width: ${breakpoint}px)`).matches
      : false;

  const [isMobile, setIsMobile] = useState<boolean>(getMatches);

  useEffect(() => {
    const media = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const onChange = (event: MediaQueryListEvent) => setIsMobile(event.matches);

    setIsMobile(media.matches);
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;
